import React from "react";
import MonthlyTimeTable from "../MonthlyTimeTable";

const JulySehriIftaar = ({districtDetails}) => {
  return <MonthlyTimeTable month={7} title="July Sehri Iftar" columnKey="3Columns" districtDetails={districtDetails} />;
};

export default JulySehriIftaar;
